import { useEffect, useState } from 'react';
import { getVariations } from '../services';
import { IVariationItem, HookState } from '../types';
import { resolveErrorMessage } from './hookUtils';

export function useVariations(
	from: string,
	to: string,
	options?: {
		sellerId?: number;
		team?: string;
		limit?: number;
		offset?: number;
		onlyNegative?: boolean;
		threshold?: number;
		enabled?: boolean;
	},
): HookState<IVariationItem[]> {
	const [state, setState] = useState<HookState<IVariationItem[]>>({
		data: null,
		loading: true,
		error: null,
		cachedAt: null,
	});

	const { sellerId, team, limit, offset, onlyNegative, threshold } = options ?? {};
	const enabled = options?.enabled ?? true;

	useEffect(() => {
		if (!from || !to || !enabled) return;

		let cancelled = false;
		const controller = new AbortController();
		setState((prev) => ({ ...prev, loading: true, error: null }));

		getVariations(from, to, { sellerId, team, limit, offset, onlyNegative, threshold })
			.then(({ data, cachedAt }) => {
				if (!cancelled) setState({ data, loading: false, error: null, cachedAt });
			})
			.catch((err) => {
				if (!cancelled && !controller.signal.aborted)
					setState({ data: null, loading: false, error: resolveErrorMessage(err), cachedAt: null });
			});

		return () => {
			cancelled = true;
			controller.abort();
		};
	}, [from, to, sellerId, team, limit, offset, onlyNegative, threshold, enabled]);

	return state;
}
